import Vue from "vue"
import { getField, updateField } from "vuex-map-fields"


export const actions = {
    openPanel({state}) {
        if (state.panel_open) return Vue.noty.error('Email is already open. Please close it to open a new one.')
        state.panel_open = true
    },
    closePanel({state}) {
        state.panel_open = false
    },
}

export const state = () => ({
    panel_open: false,
    to: [],
    cc: [],
    bcc: [],
    subject: '',
    message: '',
    attachments: [],
    copy_me: false,
    include_signature: false,
    reply_to_email_id: 0,
    conversation_id: 0,
    editEmailTemplate : null,
    isTemplateEditMode : false,
    isTemplateFormFullScreen : false,
    isProfilePagePanel : true,
    onTemplateSaved : null,
    shouldClearTemplateFields : false,

})


export const getters = {
    getField,
}


export const mutations = {
    updateField,
    setEmail(state, payload) {
      state = Object.assign(state, payload)
    },
    setIncludeSignature(state, payload) {
        state.include_signature = payload.include_signature
    },
    openEditTemplateForm(state, payload){
        // if type passed then set if it is profile page form or not otherwise it stays same
        if(payload?.isProfilePagePanel){
            state.isProfilePagePanel = payload.isProfilePagePanel;
        }

        // if not profile page then set full screen
        if(!state.isProfilePagePanel){
            state.isTemplateFormFullScreen = true;
        }

        // this is common for all profile page and non profile page email template forms
        state.editEmailTemplate = payload.editEmailTemplate;
        state.panel_open = true;
        state.isTemplateEditMode = true;
        
    },
    openAddTemplateForm(state, payload){
        // if type passed then set if it is profile page form or not otherwise it stays same
        if(payload?.isProfilePagePanel){
            state.isProfilePagePanel = payload.isProfilePagePanel;
        }

        // if not profile page then set full screen
        if(!state.isProfilePagePanel){
            state.isTemplateFormFullScreen = true;
        }

        // this is common for all profile page and non profile page email template forms
        state.editEmailTemplate = false;
        state.panel_open = true;
        state.isTemplateEditMode = false;
        
    },
    clearEmail(state) {
        state.to = []
        state.cc = []
        state.bcc = []
        state.subject = ''
        state.message = {}
        state.attachments = []
        state.copy_me = false
        state.include_signature = false
        state.reply_to_email_id = 0
        state.conversation_id = 0
    }
}
